export default{
    attr: [
        { 
            "required":1,
            "type":3,
            "show_name":"标识规范",
            "desc": "<p><span>评分标准：现场主背景板布置符合《2023年上海城市业余联赛标识和名称使用要求》。赛事标识使用有严重不规范的，原则上不评优。</span></p>",
            "options":[{"value":"符合规范","key":0},{"value":"严重不符合规范","key":1}],
            "key_name":"identifying"
        },
        // { 
        //     "required":1,
        //     "type":5,
        //     "num":1,
        //     "show_name":"上传视频",
        //     "key_name":"identifying_url"
        // },
        { 
            "required":1,
            "type":11,
            "num":9,
            "show_name":"上传照片",
            "key_name":"identifying_url2"
        },
        { 
            "required":1,
            "type":1,
            "max":4,
            "desc": "<p><span>评分标准：</span></p><p><span>①安全工作人员按照安全保障方案配备充足，分工明确；工作人员配备相应的识别标志；</span></p><p><span>②赛事（活动）现场人员、车辆、秩序等落实到位；</span></p><p><span>③赛事活动场地配备必要的消防器材以及确保无障碍设施运行良好，应急通道标识清晰。</span></p><p><span>根据项目的特点、规模与方案的详细情况及可行性评分。</span></p>",
            "show_name":"安全保障执行情况",
            "key_name":"assurance"
        },
        // { 
        //     "required":1,
        //     "type":5,
        //     "num":1,
        //     "show_name":"上传视频",
        //     "key_name":"assurance_url"
        // },
        { 
            "required":1,
            "type":11,
            "num":9,
            "show_name":"上传照片",
            "key_name":"assurance_url2"
        },
        { 
            "required":1,
            "type":4,
            "max":2,
            "desc": "<p><span>评分标准：</span></p><p><span>①赛事活动期问按照疫情防控方案，实施网格化管理，活动场所符合防疫要求，现场防疫物资数量充足；</span></p><p><span>②赛事活动现场防疫点位分布合理且有明显识别标识，防控流程线路、防疫应急动线有识别标识且清晣流畅；</span></p><p><span>③活动现场有专人负责防疫相关工作，现场有参与人员、工作人员的健康码、体温查验等工作;赛事活动有参与人员的安全承诺书或核酸检测证明或疫苗接种证明等；</span></p><p><span>④现场有隔离场所和转运安排等措施。</span></p><p><span>严格执行防疫保障计划，达到上海市疫情防控相关政策要求得满分；否则不得分。</span></p>",
            "options":[{"value":"①赛事活动期问按照疫情防控方案，实施网格化管理，活动场所符合防疫要求，现场防疫物资数量充足；","key":0},{"value":"②赛事活动现场防疫点位分布合理且有明显识别标识，防控流程线路、防疫应急动线有识别标识且清晣流畅；","key":1},{"value":"③活动现场有专人负责防疫相关工作，现场有参与人员、工作人员的健康码、体温查验等工作;赛事活动有参与人员的安全承诺书或核酸检测证明或疫苗接种证明等；","key":2},{"value":"④现场有隔离场所和转运安排等措施。","key":3},{"value":"已上皆否","key":4}],
            "show_name":"防疫保障方案执行</br><span style='color:red;'>（满足要求得满分，任何一项不符合不得分）</span>",
            "key_name":"epidemic"
        },
        // { 
        //     "required":1,
        //     "type":5,
        //     "num":1,
        //     "show_name":"上传视频",
        //     "key_name":"epidemic_url"
        // },
        { 
            "required":1,
            "type":11,
            "num":9,
            "show_name":"上传照片",
            "key_name":"epidemic_url2"
        },
        { 
            "required":1,
            "type":1,
            "max":3,
            "desc": "<p><span>评分标准：</span></p><p><span>①医务工作人员按照医务保障方案配备充足；医务工作人员配备相应的识别标志 （如着装、标牌、臂章等）；</span></p><p><span>②医务保障设施确保正常使用，并有明显标识指引。</span></p><p><span >备注：高危型及流动区域大的活动应配备救护车。</span></p><p><span>根据方案的执行情况，并结合项目的实际需要评分。</span></p>",
            "show_name":"医务保障执行情况",
            "key_name":"medical"
        },
        // { 
        //     "required":1,
        //     "type":5,
        //     "num":1,
        //     "show_name":"上传视频",
        //     "key_name":"medical_url"
        // },
        { 
            "required":1,
            "type":11,
            "num":9,
            "show_name":"上传照片",
            "key_name":"medical_url2"
        },
        { 
            "required":1,
            "type":4,
            "max":3,
            "desc": "<p><span>评分标准：</span></p><p><span>①现场主背景板布置符合“2023 年上海城市业余联赛”字样与L0GO 的规范要求；</span></p><p><span>②按照实施方案进行现场布置，赛场外围张贴指示标识，如条幅、道旗、地贴等内容；赛场内围设置宣传标语、赛事活动介绍、项目活动规则介绍等内容；</span></p><p><span>③现场各区域划分清晰并配备标识牌，如补给区、候场区、观众区等。</span></p><p><span>每满足1项得1分。</span></p>",
            "options":[{"value":"①现场主背景板布置符合“2023 年上海城市业余联赛”字样与L0GO 的规范要求；","key":0},{"value":"②按照实施方案进行现场布置，赛场外围张贴指示标识，如条幅、道旗、地贴等内容；赛场内围设置宣传标语、赛事活动介绍、项目活动规则介绍等内容","key":1},{"value":"③现场各区域划分清晰并配备标识牌，如补给区、候场区、观众区等。","key":2},{"value":"已上皆否","key":3}],
            "show_name":"赛场（或线上赛场）布置</br><span style='color:red;'>（每满足1项得1分）</span>",
            "key_name":"matchplay"
        },
        // { 
        //     "required":1,
        //     "type":5,
        //     "num":1,
        //     "show_name":"上传视频",
        //     "key_name":"matchplay_url"
        // },
        { 
            "required":1,
            "type":11,
            "num":9,
            "show_name":"上传照片",
            "key_name":"matchplay_url2"
        },
        { 
            "required":1,
            "type":1,
            "max":6,
            "desc": "<p><span>评分标准：</span></p><p><span>①工作人员（志愿者）、裁判员数量充足，任务分配明确；</span></p><p><span>②各主要环节负责人员分工明确，制定联络表，并且在整个赛事过程中有效执行；</span></p><p><span>③未出现因人员变动影响赛事活动正常进行的情况。</span></p><p><span>根据项目的特点、规模与方案的详细情况及现场秩序评分。</span></p>",
            "show_name":"组织人员投入",
            "key_name":"organizing"
        },
        // { 
        //     "required":1,
        //     "type":5,
        //     "num":1,
        //     "show_name":"上传视频",
        //     "key_name":"organizing_url"
        // },
        { 
            "required":1,
            "type":11,
            "num":9,
            "show_name":"上传照片",
            "key_name":"organizing_url2"
        },
        // { 
        //     "required":1,
        //     "type":1,
        //     "max":5,
        //     "desc": "<p><span>评分标准：</span></p><p><span>由办赛单位就赛事活动策划环节中结合节庆、文化、会展、旅游、科技、培训、论坛等提出创新认定申请。</span></p><p><span>严格按照市体总和市社体（竞赛）中心验收通过的单项《办赛指南》、《参赛指引》 精神和要求执行的飞镖、跳绳、壁球、台球、旱地冰球、网球、国际标准舞、攀岩、自由式小轮车 平衡车、龙舟、桥牌、高智尔球、跳水、电子竞技等项目，可以提出创新认定申请。</span></p><p><span>经认定后的有一项创新得1分，有两项创新得了分，有三项及以上创新得5分。</span></p>",
        //     "show_name":"策划创新",
        //     "key_name":"organizing"
        // },
        // { 
        //     "required":1,
        //     "type":5,
        //     "num":1,
        //     "show_name":"上传视频",
        //     "key_name":"organizing_url"
        // },
        // { 
        //     "required":1,
        //     "type":11,
        //     "num":1,
        //     "show_name":"上传照片",
        //     "key_name":"organizing_url2"
        // },
        // { 
        //     "required":1,
        //     "type":1,
        //     "max":5,
        //     "desc": "<p><span>评分标准：</span></p><p><span>由办赛单位就赛事活动策划环节中结合节庆、文化、会展、旅游、科技、培训、论坛等提出创新认定申请。</span></p><p><span>严格按照市体总和市社体（竞赛）中心验收通过的单项《办赛指南》、《参赛指引》 精神和要求执行的飞镖、跳绳、壁球、台球、旱地冰球、网球、国际标准舞、攀岩、自由式小轮车 平衡车、龙舟、桥牌、高智尔球、跳水、电子竞技等项目，可以提出创新认定申请。</span></p><p><span>经认定后的有一项创新得1分，有两项创新得3分，有三项及以上创新得5分。</span></p>",
        //     "show_name":"执行创新",
        //     "key_name":"innovation"
        // },
        // { 
        //     "required":1,
        //     "type":5,
        //     "num":1,
        //     "show_name":"上传视频",
        //     "key_name":"innovation_url"
        // },
        // { 
        //     "required":1,
        //     "type":11,
        //     "num":1,
        //     "show_name":"上传照片",
        //     "key_name":"innovation_url2"
        // }
    ],
    brand: [
        { 
            "required":1,
            "type":3,
            "show_name":"安全事故",
            "desc": "<p><span>评分标准：采用“一票否决”，一旦出现违反《大型群众性活动安全管理条例》规定，末按实申报，或致使发生重大伤亡事故、治安事件，食品安全事故或者新冠感染病例等，则绩效评价得分为零分。</span></p>",
            "options":[{"value":"无","key":0},{"value":"有","key":1}],
            "key_name":"accident"
        },
        // { 
        //     "required":1,
        //     "type":5,
        //     "num":1,
        //     "show_name":"上传视频",
        //     "key_name":"accident_url"
        // },
        { 
            "required":1,
            "type":11,
            "num":9,
            "show_name":"上传照片",
            "key_name":"accident_url2"
        },
        { 
            "required":1,
            "type":3,
            "show_name":"赛事投诉",
            "desc": "<p><span>有关投诉部门按到关于该项目方面投诉，经查实属于有效投诉的，则取消评奖评优资格。若投诉问题经查实并造成重大不良影响的，则采用“一票否决”，绩效评价得分为零分。</span></p>",
            "options":[{"value":"无","key":0},{"value":"有","key":1}],
            "key_name":"complaint"
        },
        // { 
        //     "required":1,
        //     "type":5,
        //     "num":1,
        //     "show_name":"上传视频",
        //     "key_name":"complaint_url"
        // },
        { 
            "required":1,
            "type":11,
            "num":9,
            "show_name":"上传照片",
            "key_name":"complaint_url2"
        },
        { 
            "required":1,
            "type":4,
            "max":2,
            "desc": "<p><span>评分标准：</span></p><p><span>1. 安全人员配备（1分）：</span></p><p><span>赛事（活动）专门配备安全工作人员得1分，赛事（活动）与场地方共同使用安全工作人员得0.5分。</span></p><p><span>2. 安全人员规范（1分）：</span></p><p><span>①安全工作人员按照安全保障方案配备充足，分工明确；工作人员配备相应的识别标志（如着装、标牌、臂章等）；</span></p><p><span>②赛事（活动）人员、车辆、秩序等落实到位；</span></p><p><span>③赛事活动场地配备必要的消防器材以及确保无障碍设施运行良好，应急通道标识清晰。</span></p><p><span>备注：高对抗性赛事应聘请具有专业资质的保安人员。</span><span>满足以上三项要求得1分，任何一项不符合不得分。</span></p>",
            "options":[{"value":"1.1 安全人员配备：赛事（活动）专门配备安全工作人员得1分。","key":0},{"value":"1.2 安全人员配备（0.5分）：赛事（活动）与场地方共同使用安全工作人员得0.5分。","key":1},{"value":"2. 安全人员规范（1分）：①安全工作人员按照安全保障方案配备充足，分工明确；工作人员配备相应的识别标志（如着装、标牌、臂章等）；②赛事（活动）人员、车辆、秩序等落实到位；③赛事活动场地配备必要的消防器材以及确保无障碍设施运行良好，应急通道标识清晰。","key":2},{"value":"已上皆否","key":3}],
            "show_name":"安全保障执行情况</br><span style='color:red;'>（每满足1项得1分，安全人员配备只选一项）</span>",
            "key_name":"assurance"
        },
        // { 
        //     "required":1,
        //     "type":5,
        //     "num":1,
        //     "show_name":"上传视频",
        //     "key_name":"assurance_url"
        // },
        { 
            "required":1,
            "type":11,
            "num":9,
            "show_name":"上传照片",
            "key_name":"assurance_url2"
        },
        { 
            "required":1,
            "type":4,
            "max":1,
            "desc": "<p><span>评分标准：</span></p><p><span>①赛事活动期问按照方案实施，配备充足的公共卫生防疫物资，办赛单位赛前应与参赛人员签订安全协议或健康承诺书；</span></p><p><span>②赛事活动现场做好消毒措施，对现场各类物品表面进行预防性消毒处理、保持环境清洁卫生。</span></p><p><span>满足要求得满分，任何一项不符合不得分。</span></p>",
            "options":[{"value":"①赛事活动期问按照方案实施，配备充足的公共卫生防疫物资，办赛单位赛前应与参赛人员签订安全协议或健康承诺书；","key":0},{"value":"②赛事活动现场做好消毒措施，对现场各类物品表面进行预防性消毒处理、保持环境清洁卫生。","key":1},{"value":"已上皆否","key":2}],
            "show_name":"防疫保障方案执行</br><span style='color:red;'>（满足要求得满分，任何一项不符合不得分）</span>",
            "key_name":"epidemic"
        },
        // { 
        //     "required":1,
        //     "type":5,
        //     "num":1,
        //     "show_name":"上传视频",
        //     "key_name":"epidemic_url"
        // },
        { 
            "required":1,
            "type":11,
            "num":9,
            "show_name":"上传照片",
            "key_name":"epidemic_url2"
        },
        { 
            "required":1,
            "type":4,
            "max":2,
            "desc": "<p><span>评分标准：</span></p><p><span>①医务工作人员按照医务保障方案配备充足，确保聘请的医务人员均具有专业资质，赛事活动现场医务工作人员配备相应的识别标志 （如着装、标牌、臂章等）；</span></p><p><span>②赛事活动现场配备充足的急救用品和药物等，医疗设施和器材配置齐全且完好有效，确保正常使用；</span></p><p><span>③赛事活动现场有明确的现场医务点，并有明显标识指引；</span></p><p><span>高危型及流动区域大的活动应配备救护车和医疗救护定点医院。</span></p><p><span>满足要求得满分，任何一项不符合不得分。</span></p>",
            "options":[{"value":"①医务工作人员按照医务保障方案配备充足，确保聘请的医务人员均具有专业资质，赛事活动现场医务工作人员配备相应的识别标志 （如着装、标牌、臂章等）；","key":0},{"value":"②赛事活动现场配备充足的急救用品和药物等，医疗设施和器材配置齐全且完好有效，确保正常使用；","key":1},{"value":"③赛事活动现场有明确的现场医务点，并有明显标识指引；高危型及流动区域大的活动应配备救护车和医疗救护定点医院。","key":2},{"value":"已上皆否","key":3}],
            "show_name":"医务保障执行情况</br><span style='color:red;'>（满足要求得满分，任何一项不符合不得分）</span>",
            "key_name":"medical"
        },
        // { 
        //     "required":1,
        //     "type":5,
        //     "num":1,
        //     "show_name":"上传视频",
        //     "key_name":"medical_url"
        // },
        { 
            "required":1,
            "type":11,
            "num":9,
            "show_name":"上传照片",
            "key_name":"medical_url2"
        },
        { 
            "required":1,
            "type":4,
            "max":2,
            "desc": "<p><span>评分标准：</span></p><p><span>①赛事承办方登录城市业余联赛官网填报赛事计划后，赛事名称经过组委会审核且通过。②现场赛事活动名称与赛事组委会审核且通过的名称完全一致，且不得缺省，不能随意添加内容。</span></p><p><span>满足要求得满分，任何一项不满足不得分。</span></p>",
            "options":[{"value":"①赛事承办方登录城市业余联赛官网填报赛事计划后，赛事名称经过组委会审核且通过。","key":0},{"value":"②现场赛事活动名称与赛事组委会审核且通过的名称完全一致，且不得缺省，不能随意添加内容。","key":1},{"value":"已上皆否","key":2}],
            "show_name":"赛事活动名称</br><span style='color:red;'>（满足要求得满分，任何一项不符合不得分）</span>",
            "key_name":"match"
        },
        // { 
        //     "required":1,
        //     "type":5,
        //     "num":1,
        //     "show_name":"上传视频",
        //     "key_name":"match_url"
        // },
        { 
            "required":1,
            "type":11,
            "num":9,
            "show_name":"上传照片",
            "key_name":"match_url2"
        },
        { 
            "required":1,
            "type":4,
            "max":3,
            "desc": "<p><span>评分标准：</span></p><p><span>①现场主背景板布置符合 “2023 年上海城市业余联赛”字样与LOGO的规范要求；</span></p><p><span>②按照实施方案进行现场布置，赛场外围张贴指示标识，如条幅、道旗、地贴等内容；赛场内围设置宣传标语、赛事活动介绍、项目活动规则介绍等内容；</span></p><p><span>③现场各区域划分清晰并配备标识牌，如补给区、候场区、观众区等。</span></p><p><span>每满足 1项得 1分。</span></p>",
            "options":[{"value":"①现场主背景板布置符合 “2023 年上海城市业余联赛”字样与LOGO的规范要求；","key":0},{"value":"②按照实施方案进行现场布置，赛场外围张贴指示标识，如条幅、道旗、地贴等内容；赛场内围设置宣传标语、赛事活动介绍、项目活动规则介绍等内容；","key":1},{"value":"③现场各区域划分清晰并配备标识牌，如补给区、候场区、观众区等","key":2},{"value":"已上皆否","key":3}],
            "show_name":"赛场（或线上赛场）布置</br><span style='color:red;'>（每满足1项得1分）</span>",
            "key_name":"layout"
        },
        // { 
        //     "required":1,
        //     "type":5,
        //     "num":1,
        //     "show_name":"上传视频",
        //     "key_name":"layout_url"
        // },
        { 
            "required":1,
            "type":11,
            "num":9,
            "show_name":"上传照片",
            "key_name":"layout_url2"
        },
        { 
            "required":1,
            "type":4,
            "max":6,
            "desc": "<p><span>评分标准：</span></p><p><span>①工作人员（志愿者）、裁判员数量充足，任务分配明确；</span></p><p><span>②裁判员等级国际级/国家级2分；国家级以下得1分（附资质证明）；</span></p><p><span>③裁判员由相应项目由市级协会的裁委会或裁判员管理机构选派，数量充足，现场服装统一。</span></p><p><span>每满足一项得2分。</span></p>",
            "options":[{"value":"①工作人员（志愿者）、裁判员数量充足，任务分配明确；","key":0},{"value":"②裁判员等级国际级/国家级2分；国家级以下得1分（附资质证明）；","key":1},{"value":"③裁判员由相应项目由市级协会的裁委会或裁判员管理机构选派，数量充足，现场服装统一。","key":2},{"value":"已上皆否","key":3}],
            "show_name":"组织人员投入</br><span style='color:red;'>（每满足1项得2分）</span>",
            "key_name":"organizing"
        },
        // { 
        //     "required":1,
        //     "type":5,
        //     "num":1,
        //     "show_name":"上传视频",
        //     "key_name":"organizing_url"
        // },
        { 
            "required":1,
            "type":11,
            "num":9,
            "show_name":"上传照片",
            "key_name":"organizing_url2"
        },
        { 
            "required":1,
            "type":1,
            "max":5,
            "desc": "<p><span>评分标准：</span></p><p><span>由办赛单位就赛事活动执行过程中的如下内容提出创新认定申报：</span></p><p><span>①主题活动开发创新：响应 “更团结”的奥林匹克格言，开发多人团体进行的活动或项目；</span></p><p><span>②内容和方式创新：包括多运动项目融合、延伸趣味活动、体验活动等环节的创新，赛场氛围布置突显活动主题；</span></p><p><span>③市场开发创新：市场开发中有3个以上赞助商；</span></p><p><span>④衍生开发创新：包括但不限于赛事纪念品开发/ 赛事吉祥物开发/赛事徽记开发；</span></p><p><span>⑤信息化应用：包括体育＋科技，线上＋线下等形式的创新。</span></p><p><span style='color:red;'>经认定后的有一项创新得1分，有两项创新得3分，有三项及以上创新得5分。</span></p>",
            "show_name":"执行创新",
            "key_name":"innovation"
        },
        // { 
        //     "required":1,
        //     "type":5,
        //     "num":1,
        //     "show_name":"上传视频",
        //     "key_name":"innovation_url"
        // },
        { 
            "required":1,
            "type":11,
            "num":9,
            "show_name":"上传照片",
            "key_name":"innovation_url2"
        }
    ],
    league: [
        { 
            "required":1,
            "type":4,
            "max":2,
            "desc": "<p><span>评分标准：</span></p><p><span>①安全工作人员按照安全保障方案配备充足，分工明确；工作人员配备相应的识别标志（如着装、标牌、臂章等）；</span></p><p><span>②赛事（活动）现场人员、车辆、秩序等落实到位;</span></p><p><span>③赛事活动场地配备必要的消防器材以及确保无障碍设施运行良好，应急通道标识清晰。</span></p><p><span>备注：高对抗性赛事应聘请具有专业资质的保安人员。</span><span>满足要求得满分，任何一项不符合不得分</span><span>。</span></p>",
            "options":[{"value":"①安全工作人员按照安全保障方案配备充足，分工明确；工作人员配备相应的识别标志（如着装、标牌、臂章等）；","key":0},{"value":"②赛事（活动）现场人员、车辆、秩序等落实到位;","key":1},{"value":"③赛事活动场地配备必要的消防器材以及确保无障碍设施运行良好，应急通道标识清晰。","key":2},{"value":"已上皆否","key":3}],
            "show_name":"安全保障执行情况</br><span style='color:red;'>（满足要求得满分，任何一项不符合不得分）</span>",
            "key_name":"assurance"
        },
        // { 
        //     "required":1,
        //     "type":5,
        //     "num":1,
        //     "show_name":"上传视频",
        //     "key_name":"assurance_url"
        // },
        { 
            "required":1,
            "type":11,
            "num":9,
            "show_name":"上传照片",
            "key_name":"assurance_url2"
        },
        { 
            "required":1,
            "type":4,
            "max":1,
            "desc": "<p><span>评分标准：</span></p><p><span>①赛事活动期问按照疫情防控方案，实施网格化管理，活动场所符合防疫要求，现场防疫物资数量充足;</span></p><p><span>②活动现场有专人负责防疫相关工作；赛事活动有参与人员的安全协议或健康承诺书。</span></p><p><span>满足要求得满分，任何一项不符合不得分。</span></p>",
            "options":[{"value":"①赛事活动期问按照疫情防控方案，实施网格化管理，活动场所符合防疫要求，现场防疫物资数量充足;","key":0},{"value":"②活动现场有专人负责防疫相关工作；赛事活动有参与人员的安全协议或健康承诺书。","key":1},{"value":"已上皆否","key":2}],
            "show_name":"防疫保障方案执行</br><span style='color:red;'>（满足要求得满分，任何一项不符合不得分）</span>",
            "key_name":"epidemic"
        },
        // { 
        //     "required":1,
        //     "type":5,
        //     "num":1,
        //     "show_name":"上传视频",
        //     "key_name":"epidemic_url"
        // },
        { 
            "required":1,
            "type":11,
            "num":9,
            "show_name":"上传照片",
            "key_name":"epidemic_url2"
        },
        { 
            "required":1,
            "type":4,
            "max":2,
            "desc": "<p><span>评分标准：</span></p><p><span>①医务工作人员按照医务保障方案配备充足；医务工作人员配备相应的识别标志（如着装、标牌、臂章等）；②医务保障设施确保正常使用，并有明显标识指引。</span></p><p><span>备注：高危型及流动区域大的活动应配备救护车。</span></p><p><span>满足要求得满分，任何一项不符合不得分。</span></p>",
            "options":[{"value":"①医务工作人员按照医务保障方案配备充足；医务工作人员配备相应的识别标志（如着装、标牌、臂章等）；","key":0},{"value":"②医务保障设施确保正常使用，并有明显标识指引","key":1},{"value":"已上皆否","key":2}],
            "show_name":"医务保障执行情况</br><span style='color:red;'>（满足要求得满分，任何一项不符合不得分）</span>",
            "key_name":"medical"
        },
        // { 
        //     "required":1,
        //     "type":5,
        //     "num":1,
        //     "show_name":"上传视频",
        //     "key_name":"medical_url"
        // },
        { 
            "required":1,
            "type":11,
            "num":9,
            "show_name":"上传照片",
            "key_name":"medical_url2"
        },
        { 
            "required":1,
            "type":4,
            "max":2,
            "desc": "<p><span>评分标准：</span></p><p><span>①赛事承办方登录城市业余联赛官网填报赛事计划后，赛事名称经过组委会审核且通过；</span></p><p><span>②现场赛事活动名称与赛事计划需一致。</span></p><p><span>满足要求得满分，任何一项不满足不得分。</span></p>",
            "options":[{"value":"①赛事承办方登录城市业余联赛官网填报赛事计划后，赛事名称经过组委会审核且通过；","key":0},{"value":"②现场赛事活动名称与赛事计划需一致。","key":1},{"value":"已上皆否","key":2}],
            "show_name":"赛事活动名称</br><span style='color:red;'>（满足要求得满分，任何一项不符合不得分）</span>",
            "key_name":"match"
        },
        // { 
        //     "required":1,
        //     "type":5,
        //     "num":1,
        //     "show_name":"上传视频",
        //     "key_name":"match_url"
        // },
        { 
            "required":1,
            "type":11,
            "num":9,
            "show_name":"上传照片",
            "key_name":"match_url2"
        },
        { 
            "required":1,
            "type":4,
            "max":3,
            "desc": "<p><span>评分标准：</span></p><p><span>①现场主背景板布置符合 “2023 年上海城市业余联赛”字样与LOGO 的规范要求；</span></p><p><span>②按照实施方案进行现场布置，舞场外围张贴指示标识，如条幅、道旗、地贴等内容；赛场内围设置宣传标语、 赛事活动介绍、项目活动规则介绍等内容；</span></p><p><span>③现场各区域划分清晰并配备标识牌，如补给区、候场区、观众区等。</span></p><p><span>每满足 1项得 1分。</span></p>",
            "options":[{"value":"①现场主背景板布置符合 “2023 年上海城市业余联赛”字样与LOGO 的规范要求；","key":0},{"value":"②按照实施方案进行现场布置，舞场外围张贴指示标识，如条幅、道旗、地贴等内容；赛场内围设置宣传标语、 赛事活动介绍、项目活动规则介绍等内容；","key":1},{"value":"③现场各区域划分清晰并配备标识牌，如补给区、候场区、观众区等。","key":2},{"value":"已上皆否","key":3}],
            "show_name":"赛场布置</br><span style='color:red;'>（每满足1项得1分）</span>",
            "key_name":"layout"
        },
        // { 
        //     "required":1,
        //     "type":5,
        //     "num":1,
        //     "show_name":"上传视频",
        //     "key_name":"layout_url"
        // },
        { 
            "required":1,
            "type":11,
            "num":9,
            "show_name":"上传照片",
            "key_name":"layout_url2"
        },
        { 
            "required":1,
            "type":4,
            "max":6,
            "desc": "<p><span>评分标准：</span></p><p><span>①工作人员（志愿者）、裁判员数量充足，任务分配明确；</span></p><p><span>②裁判员等级国际级/国家级2分；国家级以下得1分（附资质证明）；</span></p><p><span>③裁判员由相应项目由市级协会的裁委会或裁判员管理机构选派，数量充足，现场服装统一。</span></p><p><span>每满足一项得2分。</span></p>",
            "options":[{"value":"①工作人员（志愿者）、裁判员数量充足，任务分配明确；","key":0},{"value":"②裁判员等级国际级/国家级2分；国家级以下得1分（附资质证明）；","key":1},{"value":"③裁判员由相应项目由市级协会的裁委会或裁判员管理机构选派，数量充足，现场服装统一。","key":2},{"value":"已上皆否","key":3}],
            "show_name":"组织人员投入</br><span style='color:red;'>（每满足1项得2分）</span>",
            "key_name":"organizing"
        },
        // { 
        //     "required":1,
        //     "type":5,
        //     "num":1,
        //     "show_name":"上传视频",
        //     "key_name":"organizing_url"
        // },
        { 
            "required":1,
            "type":11,
            "num":9,
            "show_name":"上传照片",
            "key_name":"organizing_url2"
        },
        { 
            "required":1,
            "type":1,
            "max":5,
            "desc": "<p><span>评分标准：</span></p><p><span>由办赛单位就赛事活动策划环节的如下内容提出创新认定申报：</span></p><p><span>①结合传统节庆、文化等创新理念；</span></p><p><span>②结合会展、旅游、科技等创新理念；</span></p><p><span>③融合明星、品牌等优质IP的理念创新；</span></p><p><span>④策划培训活动、论坛等创新；</span></p><p><span>⑤“足球、篮球、乒乓球、羽毛球、轮滑、网球、橄榄球、跆拳道”等项目的赛事组织严格按照市体总和市社体（竞赛）中心验收通过的单项《办赛指南》、《参赛指引》 精神和要求执行。</span></p><p><span style='color:red;'>经认定后的有一项创新得1分，有两项创新得3分，有三项及以上创新得5分。</span></p>",
            "show_name":"执行创新",
            "key_name":"innovation"
        },
        // { 
        //     "required":1,
        //     "type":5,
        //     "num":1,
        //     "show_name":"上传视频",
        //     "key_name":"innovation_url"
        // },
        { 
            "required":1,
            "type":11,
            "num":9,
            "show_name":"上传照片",
            "key_name":"innovation_url2"
        }
    ]
}